const breakpoints = {
  values: {
    xs: 320,
    sm: 768,
    md: 1024,
    lg: 1152,
    xl: 1440
  }
};

export default breakpoints;
